import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallOnHoldIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CallOnHold",
    children: /*#__PURE__*/_jsx("path", {
      d: "m29.38 23.655-5.843-5.842a1.143 1.143 0 0 0-1.579-.036l-.793.725c-.473.43-1.2.417-1.65-.037l-6.012-6.011a1.195 1.195 0 0 1 0-1.69l.684-.684a1.143 1.143 0 0 0 0-1.616L8.345 2.62a1.144 1.144 0 0 0-1.617 1.616l5.038 5.038a3.486 3.486 0 0 0 .12 4.795l6.011 6.012a3.477 3.477 0 0 0 4.796.12l4.262 4.262-1.246 1.245c-1.108 1.11-2.582 1.72-4.15 1.72s-3.04-.61-4.149-1.72L6.291 14.59a5.84 5.84 0 0 1-1.049-6.879A1.142 1.142 0 1 0 3.22 6.648a8.12 8.12 0 0 0 1.455 9.559l11.119 11.12c1.59 1.588 3.679 2.383 5.767 2.383s4.176-.795 5.766-2.384l2.054-2.054a1.144 1.144 0 0 0 0-1.617M28.004 10.876c.63 0 1.142-.512 1.142-1.143v-5.74a1.143 1.143 0 1 0-2.285 0v5.74c0 .631.512 1.143 1.143 1.143M22.243 10.876c.631 0 1.143-.512 1.143-1.143v-5.74a1.143 1.143 0 1 0-2.285 0v5.74c0 .631.511 1.143 1.142 1.143"
    })
  }));
};
CallOnHoldIcon.displayName = 'CallOnHoldIcon';